import React from "react";
import PropTypes from "prop-types";

const CactusOne = ({ className, id }) => (
  <svg className={className} id={id} viewBox="0 0 299 706" fill="none">
    <path
      d="M236.091 439.497C231.866 467.727 231.148 485.092 230.581 514.43C229.931 548.053 231.838 560.685 234.254 600.464C236.71 640.896 238.376 701.702 238.376 701.702L178.628 703.351L118.879 705C118.879 679.974 117.741 658.992 116.879 629.516C114.994 565.05 122.219 507.029 111.065 464.474C105.921 444.85 74.7974 436.617 61.1518 420.589C27.6315 381.215 20.7334 357.517 12.0199 335.886C1.04556 308.642 0.999908 262.238 0.999908 233.2V181.394C0.999908 168.332 2.43149 146.655 4.20941 136.379C7.03024 120.075 5.44803 108.149 14.7748 95.3601C22.6831 84.5161 31.1818 78.1718 46.4365 78.8912C61.6913 79.6106 68.956 82.4087 72.6294 88.1664C80.0228 99.7548 80.5364 108.754 80.5364 122.529C80.5364 141.796 68.5703 302.996 87.6196 315.297C96.4116 320.974 98.3788 324.153 98.3788 301.241C98.3788 282.133 100.319 221.813 100.319 221.813C100.319 221.813 103.102 170.042 105.204 151.455C107.559 130.625 108.31 119.238 111.065 98.3165C113.281 81.4852 115.4 69.7446 118.879 55.0184C122.767 38.5627 121.719 32.4203 131.579 19.5924C144.1 3.3017 162.074 -1.1311 180.912 1.87985C199.75 4.89081 212.357 23.4228 223.895 38.7818C234.87 53.3901 240.793 90.5446 240.793 90.5446C240.793 90.5446 245.704 142.994 245.704 162.279C245.704 202.965 244.546 252.494 245.704 263.957C246.861 275.42 249.807 279.455 261.803 279.455C272.764 277.283 282.826 261.228 286.598 244.301C296.7 198.971 286.598 107.386 292.107 90.1306C297.616 72.8749 307.719 70.2531 320.575 70.2531C331.691 70.2531 339.86 77.9903 344.452 88.1664C349.043 98.3425 348.449 98.4002 350.365 122.886C352.281 147.373 360.064 248.001 344.453 289.631C328.843 331.26 322.19 334.888 304.965 351.612C287.3 368.764 258.216 370.522 245.704 396.942C240.443 408.051 238.613 422.644 236.091 439.497Z"
      fill="#C4C4C4"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CactusOne.defaultProps = {
  className: ``,
  id: undefined
};

CactusOne.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string
};

export default CactusOne;
